export default __webpack_public_path__ + "static/media/use_action_back2.f90b7151.png";